import React, {useEffect, useState} from 'react'
import EurestoTable from 'Components/EurestoTable'
import Utils from 'EurestoFonction/Utils'
import User from 'EurestoClass/User'
import Bus from 'EurestoClass/Bus'

export default React.memo(props => {
  const [datas, setDatas] = useState(props.datas || [])
  const [sort, setSort] = useState(props.sort || [])
  const [loading, setLoading] = useState(props.loading || false)
  const [over, setOver] = useState(props.over || true)
  const [busGUID] = useState(Utils.uuidv4())
  const [selectedRowIndex, setSelectedRowIndex] = useState(props.selectedRowIndex)

  useEffect(() => {
    if (props.infinityScroll) {
      Bus.$on('search_' + props.search, d => {
        let indexSelected
        if(props.selectedRowIndex) {
          const p = d.data.findIndex(d => d && props.selected && (d[props.columnSelected || 'id'] === props.selected[props.columnSelected || 'id']))
          indexSelected = p !== -1 ? p : undefined
          setSelectedRowIndex(indexSelected)
        }
        setDatas(d.data)
        setSort(d.sort)
        setOver(d.over)
        setLoading(false)
        props.listenerData && props.listenerData(d.data)
      }, busGUID)
    }
    Bus.$on('on_search_' + props.search, _ => {
      setOver(false)
      setLoading(true)
    }, busGUID)
    return () => {
      Bus.$off('search_' + props.search, busGUID)
      Bus.$off('on_search_' + props.search, busGUID)
    }
  }, [])

  useEffect(() => {
    setDatas(props.datas)
  }, [props.datas])

  useEffect(() => {
    setSelectedRowIndex(props.selectedRowIndex)
  }, [props.selectedRowIndex])

  return <EurestoTable datas={datas}
                       selectedRowIndex={selectedRowIndex}
                       onClick={props.onClick}
                       defaultSort={sort}
                       maxHeight={props.maxHeight || User.CalculHeight.getHeightWanted()}
                       columns={props.columns}
                       search={props.search}
                       infinityScroll={{
                         over: over || false,
                         isLoading: loading,
                       }}/>
})


// WEBPACK FOOTER //
// ./app/Components/EurestoTableSearch.js